import request from '@/utils/request'
import { getCommunityId } from '@/api/community/communityApi'

// 获取电表列表
export function listElectricMeters(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/electricMeter.listElectricMeters',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '获取电表列表失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 保存电表
export function saveElectricMeter(data) {
  // 电表号去除所有空格（含首尾、中间及全角空格），避免粘贴误带入
  const _data = {
    ...data,
    meterNo: typeof data.meterNo === 'string' ? data.meterNo.replace(/\s/g, '') : data.meterNo
  }
  return new Promise((resolve, reject) => {
    request({
      url: '/electricMeter.saveElectricMeter',
      method: 'post',
      data: _data
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '保存电表失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 更新电表
export function updateElectricMeter(data, userId, userName) {
  return new Promise((resolve, reject) => {
    request({
      url: '/electricMeter.updateElectricMeter',
      method: 'post',
      data: {
        ...data,
        userId,
        userName
      }
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '更新电表失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 变更电表号
export function changeElectricMeterNo(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/electricMeter.changeElectricMeterNo',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '变更电表号失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除电表
export function deleteElectricMeter(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/electricMeter.deleteElectricMeter',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '删除电表失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取电表充值记录列表
export function listElectricMeterRechargeRecords(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/account.listElectricMeterRechargeRecords',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '获取电表充值记录列表失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取电表扣费记录列表
export function listElectricMeterDeductionRecords(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/account.listElectricMeterDailyBills',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '获取电表扣费记录列表失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取电表状态信息
export function getElectricMeterStatus(deviceNo) {
  return new Promise((resolve, reject) => {
    request({
      url: '/electricMeter.getDeviceInfo',
      method: 'get',
      params: { deviceNo }
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '获取电表状态失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 电表开关阀命令
export function controlElectricMeterSwitch(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/electricMeter.switchValve',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '电表开关阀命令失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 电表余额变更记录
export function listElectricMeterBalanceChanges(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/electricMeter.listElectricMeterBalanceChanges',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '电表余额变更记录获取失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 导出电表扣费记录
export function exportElectricMeterDailyBill(params) {
  return new Promise((resolve, reject) => {
    params.communityId = getCommunityId()
    request({
      url: '/export.exportData',
      method: 'get',
      params: {
        ...params,
        pagePath: 'exportElectricMeterDailyBill'
      }
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '导出失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 导出电表充值记录
export function exportElectricMeterRechargeRecord(params) {
  return new Promise((resolve, reject) => {
    params.communityId = getCommunityId()
    request({
      url: '/export.exportData',
      method: 'get',
      params: {
        ...params,
        pagePath: 'exportElectricMeterRechargeRecord'
      }
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '导出失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}